"use client";

import type { FC, Ref } from "react";
import {
  Avatar,
  Flex,
  TabsNavigation,
  Text,
  type Tab,
  type UserRecord,
} from "@huub-web/ui";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface TabsTemplateProps {
  tabs: {
    /**
     * The label of the tab.
     */
    label: string;
    /**
     * The name of the tab. If not provided, the label will be used as the name.
     * @deprecated Use `user` instead.
     */
    name?: string;
    /**
     * The user of the tab. If not provided, the label will be used as the name.
     */
    user?: UserRecord;
    /**
     * The templates of the tab when opened.
     */
    templates: TemplateCollection;
  }[];
}

/**
 * A template for a tabs component.
 * @deprecated 💀
 */
export const TabsTemplate: FC<
  TabsTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ tabs, ref, ...props }) => {
  const parsedTabs: Tab[] = tabs.map((tab, i) => ({
    id: `${i}`,
    label:
      tab.user || tab.name ? (
        <Flex gap="xs" justify="center" align="center">
          <Avatar
            id={tab.user?.id}
            value={tab.user?.name || tab.name}
            size="xs"
            variant="secondary"
          />
          <Text ellipsis>{tab.label}</Text>
        </Flex>
      ) : (
        tab.label
      ),
    content: (
      <Flex direction="column" gap="s">
        <TemplatesParser level={1} templates={tab.templates} />
      </Flex>
    ),
  }));

  return (
    <TabsNavigation
      ref={ref}
      tabs={parsedTabs}
      variant="outlined"
      color="background"
      {...props}
    />
  );
};
